module.exports = __webpack_public_path__ + "static/media/Seam_6720.1bce5438.jpg";